import React, { FC, useRef, useState } from 'react';
import { useField } from 'formik';
import cn from 'classnames';

import { useOnClickOutside } from 'client/hooks';

import { InputTypesT } from 'client/types';

import css from './Input.module.scss';

type Props = {
  className?: string;
  inputClassName?: string;
  name: string;
  label: string;
  placeholder: string;
  type: InputTypesT;
  isEmail?: boolean;
};

const Input: FC<Props> = (props) => {
  const { name, className = '', inputClassName = '', label, placeholder, type, isEmail = false } = props;
  const [titleVisibility, setTitleVisibility] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const [field, meta] = useField(name);
  const isFieldHasError: boolean = meta.touched && !!meta.error;

  const placeHolderText: string = !titleVisibility ? placeholder : '';

  const onHideTitle = (): void => {
    if (field.value === '') setTitleVisibility(false);
  };

  useOnClickOutside(inputRef, onHideTitle);

  const isInput: boolean = type !== 'checkbox';

  return (
    <div className={cn(css.container, className)}>
      {isInput ? (
        <>
          <div className={css.label}>{titleVisibility && <span>{label}</span>}</div>
          <div className={cn(css.input, isFieldHasError && css.error)}>
            <input
              {...field}
              ref={inputRef}
              type={type}
              placeholder={placeHolderText}
              onClick={() => setTitleVisibility(true)}
              className={cn(inputClassName, isEmail && css.emailInput)}
            />
          </div>
          {isFieldHasError && (
            <div className={css.errorMsg}>
              <span>{meta.error}</span>
            </div>
          )}
        </>
      ) : (
        <>
          <div className={css.checkbox}>
            <label className={cn(css.container, isFieldHasError && css.error)}>
              <div className={css.checkboxWrapper}>
                <input type={type} {...field} />
                <span className={css.checkmark}></span>
              </div>
              <span dangerouslySetInnerHTML={{ __html: label }}></span>
            </label>
          </div>
          {isFieldHasError && (
            <div className={css.checkboxErrorMsg}>
              <span>{meta.error}</span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Input;
